import { CommonModule } from '@angular/common';
import { NgModule, OnInit } from '@angular/core';
import { ProcorManutencaoComunicadoService } from '../../administrativo/procor-manutencao-comunicado/service/procor-manutencao-comunicado.service';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { DocumentosService } from '../../shared/services/documentos.service';
import { PessoaService } from '../../shared/services/pessoa.service';
import { AcessoLinksDocumentosComponent } from './acesso-links-documentos.component';
import { AcessoLinksDocumentosRoutingModule } from './router/acesso-links-documentos.router';
import { AcessoLinksDocumentosService } from './service/acesso-links-documentos.service';


@NgModule({
  imports: [
    CommonModule,
    AreaRestritaSharedModule,
    AcessoLinksDocumentosRoutingModule
  ],
  declarations: [AcessoLinksDocumentosComponent],
  exports: [
    AcessoLinksDocumentosComponent
  ],
  providers: [
    PessoaService,
    ProcorManutencaoComunicadoService,
    AcessoLinksDocumentosService,
    DocumentosService
]
})
export class AcessoLinksDocumentosModule implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/institucional/acesso-links-documentos/acesso-links-documentos.module.ts